import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

interface WechatGuideProps {
  visible: boolean;
  onClose?: () => void;
}

const WechatGuide: React.FC<WechatGuideProps> = ({ visible, onClose }) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <div className="wechat-guide-mask">
      <div className="guide-content">
        
        <div className="guide-text">
          {t("wxGuide")}
        </div>
        <div className="guide-text">{location.href}</div>
        <button className="guide-close-btn" onClick={onClose}>
          {t("我知道了")}
        </button>
      </div>
    </div>
  );
};

export default WechatGuide;
